import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { VerifyEmailResponse } from '../interface/verify-email-response.interface';
import { ApiUrlConstants } from '@core/constants/api.constants';


@Injectable()
export class AccountService {
    constructor(private httpClient: HttpClient) { }

    /**
     * @description email
     * @date 2020-01-02
     * @param {string} fboId
     * @param {string} expiryCode
     * @returns {Observable<VerifyEmailResponse>}
     * @memberof AccountService
     */
    validateUserEmailExpiryCode(fboId: string, expiryCode: string): Observable<VerifyEmailResponse> {
        return this.httpClient.get<VerifyEmailResponse>
        (decodeURIComponent(encodeURIComponent((ApiUrlConstants.ACCOUNT_BASE + 'flp360-users/verify-email/' + fboId + '?expiryCode=' + expiryCode))));
    }

    updateSocialsalesEmailId(fboId: string) {
        const url = ApiUrlConstants.ACCOUNT_BASE + 'flp360/user/' + fboId + '/update';
        return this.httpClient.patch(url, {isEmailVerified : true});
    }
}